import type { CSSProperties } from "react";
import { cn } from "@/lib/utils";
export function Skeleton({
  className,
  style
}: {
  className?: string;
  style?: CSSProperties;
}) {
  return <div style={style} className={cn("animate-pulse rounded-small bg-offwhite-2", className)} data-sentry-component="Skeleton" data-sentry-source-file="Skeleton.tsx" />;
}
export function SkeletonText({
  children,
  className
}: {
  children: string;
  className?: string;
}) {
  return <span aria-hidden className={cn("inline-block animate-pulse rounded-small bg-offwhite-2 text-transparent", className)} data-sentry-component="SkeletonText" data-sentry-source-file="Skeleton.tsx">
            {children}
        </span>;
}